import React from 'react';
import '../styles/Portfolio.scss';
import Tile from './Tile';

const Portfolio = ({ projects }) => (
  <section className="Portfolio">
    <div className='row'>
    {Object.keys(projects).map((projectId, i) => {
      const project = projects[projectId];
      return <Tile project={project} projectId={projectId} key={i} />
    })}
    </div>
  </section>
);

Portfolio.propTypes = {
  projects: React.PropTypes.object
};

export default Portfolio;



// WEBPACK FOOTER //
// ./src/components/Portfolio.js